import React, {FunctionComponent, useEffect, useRef} from 'react';
import './DrawerDescription.less';
import {applyTags} from '../../../helpers/format.helper';

interface DrawerDescriptionProps {
	text: string | JSX.Element,
	isFullSize?: boolean,
	onExternalLinkClick?: (link: string) => void,
	onRestaurantLinkClick?: (restaurantId: number) => void,
	onMenuEntryLinkClick?: (mainCategoryId: number, categoryId: number, menuEntryId: number) => void,
}

export const DrawerDescription: FunctionComponent<DrawerDescriptionProps> = ({text, isFullSize = false, onExternalLinkClick, onRestaurantLinkClick, onMenuEntryLinkClick}) => {
	const containerRef = useRef();
	useEffect(() => {
		function triggerClick(event) {
			event.preventDefault();

			if (event.target?.dataset['restaurantid']) {
				onRestaurantLinkClick(parseInt(event.target.dataset['restaurantid']));

				return;
			}
			if (event.target?.dataset['itemid']) {
				onMenuEntryLinkClick(parseInt(event.target.dataset['menuid']), parseInt(event.target.dataset['categoryid']), parseInt(event.target.dataset['itemid']));

				return;
			}

			if (event.target?.href) {
				onExternalLinkClick(event.target?.href);
			}
			window['__trigger'] = event;
		}

		// @ts-ignore
		containerRef.current?.addEventListener('click', triggerClick);

		return () => {
			// @ts-ignore
			containerRef.current?.removeEventListener('click', triggerClick);
		};

	}, []);
	if (typeof text === 'string') {
		return <p
			className={`drawer-description ${isFullSize ? 'drawer-description--full-size' : ''}`}
			dangerouslySetInnerHTML={{__html: applyTags(text)}}
			ref={containerRef}
		></p>;
	} else {
		return <p
			className={`drawer-description ${isFullSize ? 'drawer-description--full-size' : ''}`}
			ref={containerRef}
		>
			{text}
		</p>;
	}
};
